<script setup>
import {ref, watch} from "vue";
import {
  Listbox,
  ListboxLabel,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'
import { CheckIcon, SelectorIcon as ChevronUpDownIcon } from '@heroicons/vue/solid'
import {getActiveLanguage, loadLanguageAsync} from "laravel-vue-i18n";
import {Inertia} from "@inertiajs/inertia";
import {Ziggy} from "@/ziggy";

const asset = (path) => {
  var base_path = window._asset || location.origin;
  if (!path.startsWith('/')) path = "/" + path;

  // Extract the first segment of the path
  var firstSegment = path.split('/')[1];

  // Check if the first segment is 'de' or 'en' and remove it
  if (['de', 'en'].includes(firstSegment)) {
    path = path.replace('/' + firstSegment, '');
  }

  return base_path + path;
};

const languages = [
  { name: 'German', icon: asset('build/flags/162-germany.svg'), key: 'de' },
  { name: 'English', icon: asset('build/flags/226-united-states.svg'), key: 'en' },
]
const selectedLanguage = ref(languages.filter(l => l.key === getActiveLanguage())[0]);

const props = defineProps({
  colorScheme: {
    type: String,
    default: 'dark',
  },
  inertiaRequest: {
    type: Boolean,
    default: false,
  }
});

watch(selectedLanguage, (n, o) => {
  // loadLanguageAsync(n.key);
  // if (props.inertiaRequest) {
    window.location.href = getReplacedUri(n.key);
  //   Inertia.replace(getReplacedUri(n.key), {}, {
  //     preserveScroll: false,
  //     preserveState: false,
  //   });
  // changeLocale(n.key);
    // Inertia.post(route('language.update'), { language: n.key }, {
    //   preserveScroll: true,
    //   preserveState: false,
    //   onSuccess() {
    //     Inertia.replace(getReplacedUri(n.key));
    //   }
    // })
  // } else {
  //   axios.post(route('language.update'), { language: n.key });
  // }
});

const getReplacedUri = (locale) => {
  const currentURI = window.location.pathname; // Get the current URI without params
  const segments = currentURI.split('/').filter(Boolean); // Split URI into segments

  // Check if the first segment is a supported locale
  if (segments.length > 0 && ['en', 'de'].includes(segments[0])) {
    // Replace the existing locale with the new one and return the modified URI
    segments[0] = locale;
    return '/' + segments.join('/');
  } else {
    // If no locale segment is found, add the given locale to the start of the URI
    return '/' + locale + currentURI;
  }
}
</script>

<template>
  <Listbox v-model="selectedLanguage">
    <div class="relative mt-1">
      <ListboxButton
          :class="{'border border-gray-700 text-gray-200': colorScheme === 'dark', 'bg-white': colorScheme === 'light'}"
          class="relative w-full cursor-default rounded-md py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-primary-300 sm:text-sm"
      >
        <div class="block truncate flex space-x-2">
          <span class="absolute inset-y-0 left-0 flex items-center pl-3">
            <img :src="selectedLanguage.icon" :alt="__(selectedLanguage.name)" class="h-6 w-auto" draggable="false">
          </span>
          <span class="pl-6">{{ __(selectedLanguage.name) }}</span>
        </div>
        <span
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2"
        >
            <ChevronUpDownIcon
                class="h-5 w-5 text-gray-400"
                aria-hidden="true"
            />
          </span>
      </ListboxButton>

      <transition
          leave-active-class="transition duration-100 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
      >
        <ListboxOptions
            :class="{'bg-gray-700 text-gray-400': colorScheme === 'dark', 'bg-white': colorScheme === 'light'}"
            class="absolute mt-1 max-h-60 w-full overflow-auto rounded-md py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm z-50"
        >
          <ListboxOption
              v-slot="{ active, selected }"
              v-for="language in languages"
              :key="language.name"
              :value="language"
              as="template"
          >
            <li
                :class="[active ? 'bg-gray-600 text-white' : (colorScheme === 'dark' ? 'text-gray-200' : 'text-gray-900'),
                  'relative cursor-default select-none py-2 pl-10 pr-6']">
                <span :class="[selected ? 'font-medium' : 'font-normal', 'block truncate']">{{ __(language.name) }}</span>
                <span class="absolute inset-y-0 left-0 flex items-center pl-3 rounded-lg overflow-hidden">
                  <img :src="language.icon" :alt="language.name" class="h-6 w-auto" draggable="false">
                </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>